export default __webpack_public_path__ + "static/media/TrashIcon.93540cb3.svg";